var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = normalizeQuery = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2hlbHBlci9tX25vcm1hbGl6ZVF1ZXJ5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9oZWxwZXIvbV9ub3JtYWxpemVRdWVyeS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQyxlQUFnQixPQUFBLENBQVEsdURBQVI7O0FBQ2pCLE1BQUEsR0FBUyxZQUFBLEdBQWU7O0FBRXhCLFVBQUEsR0FBYSxTQUFBO0FBRVgsTUFBQTtFQUFBLE9BQUEsR0FBVSxNQUFNLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsV0FBdkIsSUFBc0M7RUFFaEQsWUFBQSxHQUFlO0VBQ2YsTUFBQSxHQUFTO0VBRVQsR0FBQSxHQUFNLENBQUMsQ0FBQyxNQUFGLENBQVMsT0FBVDtFQUNOLEdBQUEsR0FBTSxDQUFDLENBQUMsSUFBRixDQUFPLE9BQVA7RUFDTixNQUFBLEdBQWMsSUFBQSxNQUFBLENBQU8sR0FBQSxHQUFNLFlBQUEsQ0FBYSxHQUFHLENBQUMsSUFBSixDQUFTLEVBQVQsQ0FBYixDQUFOLEdBQW1DLEdBQTFDLEVBQStDLEdBQS9DO0VBQ2QsR0FBQSxHQUFNLEdBQUcsQ0FBQztBQUNWLFNBQU0sR0FBQSxFQUFOO0lBQ0UsR0FBQSxHQUFNLEdBQUcsQ0FBQyxHQUFKLENBQUE7SUFDTixJQUFBLEdBQU8sR0FBRyxDQUFDLEdBQUosQ0FBQTtBQUNQLFNBQUEsdUNBQUE7O01BQUEsWUFBYSxDQUFBLElBQUEsQ0FBYixHQUFxQjtBQUFyQjtFQUhGO1NBS0E7QUFoQlc7O0FBa0JiLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQUEsR0FBaUIsU0FBQyxDQUFEO0VBQ2hDLElBQWlCLE9BQU8sQ0FBUCxLQUFZLFFBQTdCO0FBQUEsV0FBTyxHQUFQOztFQUNBLENBQUEsR0FBSSxDQUFDLENBQUMsSUFBRixDQUFBLENBQVEsQ0FBQyxPQUFULENBQWtCLE1BQUEsSUFBVSxVQUFBLENBQUEsQ0FBNUIsRUFBMkMsU0FBQyxDQUFEO1dBQzdDLFlBQWEsQ0FBQSxDQUFBO0VBRGdDLENBQTNDO1NBRUosQ0FBQyxDQUFDLFdBQUYsQ0FBQTtBQUpnQyJ9
